import { productFilesApi } from "@/services/api/productFiles.api";

export const productFilesState = {
  state: {
    files: [],
    loading: false,
    uploading: false,
    error: "",
  },
  mutations: {
    PRODUCT_FILES_FETCH_SUCCESS(state, payload) {
      state.files = payload;
      state.loading = false;
      state.error = "";
    },
    PRODUCT_FILES_FETCH_START(state) {
      state.loading = true;
      state.error = "";
    },
    PRODUCT_FILES_FETCH_ERROR(state, payload) {
      state.loading = false;
      state.error = payload;
    },
    PRODUCT_FILE_UPLOAD_START(state) {
      state.uploading = true;
      state.error = "";
    },
    PRODUCT_FILE_UPLOAD_SUCCESS(state, payload) {
      state.files.unshift(payload);
      state.uploading = false;
      state.error = "";
    },
    PRODUCT_FILE_UPLOAD_ERROR(state, payload) {
      state.uploading = false;
      state.error = payload;
    },
    PRODUCT_FILE_DELETE_SUCCESS(state, productFileId) {
      state.files = state.files.filter(file => file.productFileId !== productFileId);
      state.error = "";
    },
    PRODUCT_FILE_DELETE_ERROR(state, payload) {
      state.error = payload;
    },
    PRODUCT_FILE_UPDATE_SUCCESS(state, payload) {
      const index = state.files.findIndex(file => file.productFileId === payload.productFileId);
      if (index !== -1) {
        state.files.splice(index, 1, payload.productFile );
     }
      state.error = "";
    },
    PRODUCT_FILE_UPDATE_ERROR(state, payload) {
      state.error = payload;
    }
  },
  actions: {
    getProductFiles(context, productId) {
      context.commit("PRODUCT_FILES_FETCH_START");

      const promise = new Promise((resolve, reject) => {
        productFilesApi
          .getProductFiles(productId)
          .then(response => {
            context.commit("PRODUCT_FILES_FETCH_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            context.commit("PRODUCT_FILES_FETCH_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },

    uploadProductFile(context, { productId, file }) {
      context.commit("PRODUCT_FILE_UPLOAD_START");

      const promise = new Promise((resolve, reject) => {
        productFilesApi
          .uploadFile(productId, file)
          .then(response => {
            // Add the new file to the list
            const newFile = {
              productFileId: response.data.productFileId,
              // productId: productId,
              productId,
              originalFileName: file.name,
              fileExtension: file.name.split(".").pop(),
              fileSize: file.size,
              contentType: file.type,
              description: "",
              createdDate: new Date().toISOString(),
              user: {
                userName: "Current User" // This will be updated when we refetch
              }
            };
            context.commit("PRODUCT_FILE_UPLOAD_SUCCESS", newFile);
            resolve(response);
          })
          .catch(error => {
            context.commit("PRODUCT_FILE_UPLOAD_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },

    deleteProductFile(context, productFileId) {
      const promise = new Promise((resolve, reject) => {
        productFilesApi
          .deleteFile(productFileId)
          .then(response => {
            context.commit("PRODUCT_FILE_DELETE_SUCCESS", productFileId);
            resolve(response);
          })
          .catch(error => {
            context.commit("PRODUCT_FILE_DELETE_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },

    updateFileDescription(context, { productFileId, description }) {
      const promise = new Promise((resolve, reject) => {
        productFilesApi
          .updateFileDescription(productFileId, description)
          .then(response => {
            context.commit("PRODUCT_FILE_UPDATE_SUCCESS", { productFileId, description, productFile: response.data.productFile });
            resolve(response);
          })
          .catch(error => {
            context.commit("PRODUCT_FILE_UPDATE_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },

    downloadProductFile(context, productFileId) {
      return productFilesApi.downloadFile(productFileId);
    }
  },
};
